import { render } from "./BarMenu.vue?vue&type=template&id=0b0941d8"
import script from "./BarMenu.vue?vue&type=script&lang=js"
export * from "./BarMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/romain/Developer/vue-file-toolbar-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__